import React, { useState, useEffect } from 'react';
import '../styles/OnboardingPopup.css';

function OnboardingPopup() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if this is the first visit
    const hasSeenPopup = localStorage.getItem('hasSeenOnboarding');
    
    if (!hasSeenPopup) {
      // Show popup after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  const closePopup = () => {
    setIsVisible(false);
    // Save to localStorage to prevent showing again
    localStorage.setItem('hasSeenOnboarding', 'true');
  };
  
  if (!isVisible) return null;
  
  return (
    <div className="popup-overlay">
      <div className="onboarding-popup">
        <button className="close-button" onClick={closePopup}>×</button>
        
        <div className="popup-header">
          <div className="popup-logo">
            <img src="/assets/Logo.PNG" alt="Sunny Sideup Storys Logo" className="popup-logo-img" />
          </div>
        </div>
        
        <div className="popup-content">
          <p>
            Welcome to the world of <br/> <b style={{color: '#f09b2b;'}}> Original Indian Horror Fiction </b> <br/>
          </p>
          
          <div className="onboarding-image-container">
            <img 
              src="/assets/story-images/onboarding-cover.JPEG" 
              alt="Vibe Reader Experience" 
              className="onboarding-cover-image" 
            />
          </div>
          
          <p>
            Buckle up for <b> The Vibe Reader </b> -- an electrifying new way to read horror. Sunny Sideup Story's immersive web and mobile apps are launching soon, featuring the complete catalog that's already captivating Instagram followers at (<a 
              href="https://instagram.com/sunnysideup_storys" 
              target="_blank" 
              rel="noopener noreferrer"
              className="insta-link"
            >@sunnysideup_storys</a>).
          </p>
          
          <p className="highlight-text">
            Create a <strong>FREE</strong> account now and experience the Vibe Reader with limited stories absolutely free!
          </p>
          
          <div className="popup-features">
            <div className="feature">
              <span className="feature-icon">🎧</span>
              <span className="feature-text">Ambient BGM</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🌧️</span>
              <span className="feature-text">Atmospheric Sounds</span>
            </div>
            <div className="feature">
              <span className="feature-icon">📱</span>
              <span className="feature-text">Distracted Mode</span>
            </div>
          </div>
        </div>
        
        <div className="popup-footer">
          <button className="cta-button" onClick={closePopup}>Start Reading</button>
        </div>
      </div>
    </div>
  );
}

export default OnboardingPopup; 